import { useRef } from 'react'
import { Appliance } from '../classes/appliances/Appliance'
import { SystemControl } from '../classes/SystemControl'

/**
 * Everything the appliance page sends on save, as one comparable string: the
 * appliance name and config, and the pending (unsent) config of every port.
 */
export function applianceEditState(appliance: Appliance, control: SystemControl): string {
  return JSON.stringify({
    name: appliance.name,
    config: appliance.config,
    pending: control.pendingConfig(),
  })
}

/**
 * Whether `state` differs from the first defined state seen, i.e. from the
 * page as it was when loaded. Pass `undefined` until the page has loaded.
 *
 * The page applies its own load-time fixes (defaults, `enabled` repair) before
 * the first defined state, so those do not count as edits; an edit changed back
 * to its original value no longer does either.
 */
export function useUnsavedChanges(state: string | undefined): boolean {
  const baseline = useRef<string>()
  if (state === undefined) return false
  if (baseline.current === undefined) baseline.current = state
  return state !== baseline.current
}
